import './index.scss';
import 'utils/favorites_toggle';
import { EventManager } from 'utils/event_manager';

(() => {
  function favorite(resourceId) {
    const btn = document.querySelector(
      `.js-favorite[data-resource="${resourceId}"]`
    );

    if (btn.classList.contains('is-following')) {
      return;
    }

    btn.click();
  }

  EventManager.subscribe('followOnComment', (_, resourceId) =>
    favorite(resourceId)
  );
})();
